import { VariableWithConclusion } from '~/packages/general/variable/variables.typing'
import VariableSelectionDetails from '~/components/mapContent/modals/variable/selectionDetails'

interface ViewSelectModalVariableSelectionDetailsProps {
  variable: VariableWithConclusion
}

export default function ViewSelectModalVariableSelectionDetails({
  variable,
}: ViewSelectModalVariableSelectionDetailsProps) {
  return <VariableSelectionDetails variable={variable} />
}
